<template>
  <div id="ChannelDecommissionForm">
    <div class="row" id="channel-d-main-section">
      <div class="row">
        <div class="col-md-12">
          <RequestType
            v-show="ImportChannels === null || currentStepName == 'Import Data'"
            @request-type="onRequestTypeClick"
            @set-Channel-Decommission="setImportExcelDatasource"
            @show-next-step="checkNextStep"
            ref="importExcelRef"
          />
          <DecommissionChannel
            v-show="
              currentStepName == 'Decommission Channels' &&
              ImportChannels !== null
            "
            ref="decommissionChannelRef"
            @selected-data="selectedGridData"
          />
          <ConfirmationScreen
            v-show="currentStepName == 'Confirmation'"
            ref="confirmationRef"
            :selectedRowsData="selectedRowData"
            @requested-date="requestedDate"
          />
        </div>
      </div>
    </div>
    <div class="row" id="customStepperSection">
      <div class="col-md-12">
        <CustomStepper
          v-show="ImportChannels !== null && currentStepName !== 'Import Data'"
          :steps="steps"
          :currentStepIdx.sync="currentStepIdx"
          :currentStepName="currentStepName"
          :completedStepIdx="completedStepIdx"
          :requiredFieldNeeded="!IsCurrentStepValid"
          :continueBtnHoverText="continueBtnHoverText"
          :diabledToolTip="diabledToolTip"
          @show-last-step="currentStepIdx--"
          @show-next-step="checkNextStep"
          @hide-modal="hideModal"
        />
      </div>
    </div>
    <DxLoadPanel
      :position="loaderPosition"
      :visible.sync="loaderVisible"
      :show-indicator="true"
      shading-color="rgba(0,0,0,0.4)"
      :delay="250"
      :shading="true"
    />
  </div>
</template>
<script>
import notify from "devextreme/ui/notify";
import CustomStepper from "../../views/stepper/CustomStepper.vue";
import { DxLoadPanel } from "devextreme-vue/load-panel";
import DecommissionChannel from "../../views/channelsDecommissionRequest/decommissionChannels/DecommissionChannel";
import ConfirmationScreen from "../../views/channelsDecommissionRequest/confirmationScreen/ConfirmationScreen";
import RequestType from "../../views/channelsDecommissionRequest/requestType/RequestType";
export default {
  name: "ChannelDecommissionForm",
  components: {
    CustomStepper,
    DxLoadPanel,
    DecommissionChannel,
    ConfirmationScreen,
    RequestType,
  },
  data() {
    return {
      loaderPosition: { of: "#ChannelDecommissionForm" },
      ImportChannels: null,
      FromImport: false,
      loaderVisible: false,
      user: this.$auth.user.UserDetails,
      steps: [
        {
          StepName: "Decommission Channels",
          ModalHeader: "Request Channel to Decommission",
          ShowBackButton: false,
          ShowNextButton: true,
          NextButtonText: "Confirm Decomm. List",
          ComponentRef: "decommissionChannelRef",
          ValidateStep: false,
        },
        {
          StepName: "Confirmation",
          ModalHeader: "Confirm Channels to be Decommissioned",
          ShowBackButton: true,
          ShowNextButton: true,
          NextButtonText: "Submit",
          ComponentRef: "confirmationRef",
          ValidateStep: false,
        },
      ],
      currentStepIdx: 0,
      completedStepIdx: 0,
      DisabledTooltipMessages: [],
      selectedRowData: [],
      ClientRequestObj: [],
      ReuestedDateConfirm: null,
    };
  },
  created: function () {},
  watch: {
    currentStepIdx(newValue) {
      if (newValue > this.completedStepIdx) {
        this.completedStepIdx = newValue;
      }
    },
  },
  computed: {
    IsCurrentStepValid() {
      return this.steps[this.currentStepIdx].ValidateStep
        ? this.$refs[
            this.steps[this.currentStepIdx].ComponentRef
          ].validateStep()
        : true;
    },
    currentStepName() {
      this.$emit("set-title", this.steps[this.currentStepIdx].ModalHeader);
      return this.steps[this.currentStepIdx].StepName;
    },
    continueBtnHoverText() {
      return this.IsCurrentStepValid
        ? "All Required fields must be filled in to continue."
        : "";
    },
    diabledToolTip() {
      return this.getDisabledTooltips();
    },
  },
  methods: {
    setImportExcelDatasource(data) {
      this.selectedRowData = data;
      this.FromImport = true;
    },
    onRequestTypeClick(type) {
      let MultipleSteps = [
        {
          StepName: "Decommission Channels",
          ModalHeader: "Request Channel to Decommission",
          ShowBackButton: false,
          ShowNextButton: true,
          NextButtonText: "Confirm Decomm. List",
          ComponentRef: "decommissionChannelRef",
          ValidateStep: false,
        },
        {
          StepName: "Confirmation",
          ModalHeader: "Confirm Channels to be Decommissioned",
          ShowBackButton: true,
          ShowNextButton: true,
          NextButtonText: "Submit",
          ComponentRef: "confirmationRef",
          ValidateStep: false,
        },
      ];
      let SingleSteps = [
        {
          StepName: "Import Data",
          ModalHeader: "Request Channel to Decommission",
          ShowBackButton: false,
          ShowNextButton: true,
          NextButtonText: "Continue",
          ComponentRef: "importExcelRef",
          ValidateStep: false,
        },
        {
          StepName: "Confirmation",
          ModalHeader: "Confirm Channels to be Decommissioned",
          ShowBackButton: true,
          ShowNextButton: true,
          NextButtonText: "Submit",
          ComponentRef: "confirmationRef",
          ValidateStep: false,
        },
      ];
      if (!type) {
        this.ImportChannels = false;
        this.steps = MultipleSteps;
        // this.steps.shift();
      } else {
        this.ImportChannels = true;
        this.steps = SingleSteps;
      }
    },
    requestedDate(data) {
      this.ReuestedDateConfirm = data;
    },
    hideModal() {
      this.$emit("hide-modal");
    },
    sendData() {
      //Final Object
      if (this.FromImport) {
        this.selectedRowData.forEach((element) => {
          let itemOjb = {
            ProductInstanceID: element.ProductInstanceID,
            RequestedDate: element.RequestedDate
              ? new Date(element.RequestedDate).toISOString()
              : new Date().toISOString(),
          };
          this.ClientRequestObj.push(itemOjb);
        });
      } else {
        this.selectedRowData.forEach((element) => {
          let itemOjb = {
            ProductInstanceID: element.ProductInstanceID,
            RequestedDate: this.ReuestedDateConfirm
              ? this.ReuestedDateConfirm.toISOString()
              : new Date().toISOString(),
          };
          this.ClientRequestObj.push(itemOjb);
        });
      }
      let jsonData = {
        RequestTypeID: 3, // Hard Code For Decommission
        Company_RecID: this.user.Company_RecID, // Company of User
        Contact_RecID: this.user.Contact_RecID, // Contact_RecID of logged in user
        ClientRequestObj: this.ClientRequestObj,
      };
      console.log(jsonData);
      this.saveChannelDecommissionQuote(jsonData);
    },
    saveChannelDecommissionQuote(data) {
      this.loaderVisible = true;
      let th = this;
      const URL = `https://api.ccr.net/ColoM360/clientrequest/decomm`;
      this.$axios.post(URL, data).then((response) => {
        notify(
          {
            message: "Request submitted successfully!",
            position: {
              my: "center top",
              at: "center top",
            },
            width: "300px",
          },
          "success",
          5000
        );
        th.loaderVisible = false;
        th.hideModal();
      });
    },
    checkNextStep() {
      if (this.currentStepIdx + 1 === this.steps.length) {
        this.sendData();
      } else {
        this.currentStepIdx++;
      }
    },
    setDisabledTooltip(disabledTooltip) {
      this.DisabledTooltipMessages = [];
      this.DisabledTooltipMessages = disabledTooltip;
    },
    getDisabledTooltips() {
      let msgs = "";
      if (this.DisabledTooltipMessages.length === 0)
        return "All Required fields must be filled in to continue.";
      this.DisabledTooltipMessages.forEach((msg, i) => {
        msgs +=
          "<i>- " +
          msg +
          "</i>" +
          (this.DisabledTooltipMessages.length - 1 !== i ? "<br/>" : "");
      });
      return msgs;
    },
    selectedGridData(data) {
      this.selectedRowData = data;
      //console.log(data)
    },
  },
};
</script>
<style lang="scss" scoped>
#channel-d-main-section {
  height: 400px;
  padding: 0;
  overflow-y: 0;
  overflow-x: hidden;
}
.overflow-auto {
  overflow: hidden;
}
</style>